import * as axios from "axios";

export const GET_TEST_MESSAGE_START = 'GET_TEST_MESSAGE_START';
export const GET_TEST_MESSAGE = 'GET_TEST_MESSAGE';

export const getTestMessage = () => dispatch => {
    dispatch({type: GET_TEST_MESSAGE_START});

    const payload = axios.get('/api/test1');
    dispatch({
        type: GET_TEST_MESSAGE,
        payload
    });
};


// WEBPACK FOOTER //
// ./src/containers/app/AppActions.js